<div class="container-fluid reset-container">
    <div class="row reset-wrapper">
      <!-- Left Image Section (Desktop) -->
      <div class="col-lg-7 d-none d-lg-block image-container">
        <img src="https://kontact-app-public.s3-ap-southeast-1.amazonaws.com/images/Reset-Password.png" alt="Reset Password">
      </div>
  
      <!-- Reset Password Form Section -->
      <div class="col-lg-5 col-12 d-flex align-items-center justify-content-center reset-form-container">
        <div class="reset-box glass-effect">
          <h3 class="reset-heading">Reset Password</h3>
          <p class="reset-description">Don't worry, it happens to the best of us.</p>
  
          <form [formGroup]="forgotPasswordForm">
            <ng-container >
              <div class="form-group">
                <input type="text" formControlName="email" class="form-control" placeholder="Email*">
              </div>
              <div class="text-center mt-3">
                <button type="button" class="btn btn-lite-blue"
        (click)="sendOTP()" [disabled]="!forgotPasswordForm.valid">
  Email me an OTP
</button>

              </div>
            </ng-container>
          </form>
  
          <div class="text-center back-link">
            <a  (click)="backTosignIn()" >Back to Sign In</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  